
import { FormBuilder, FormGroup } from '@angular/forms';

import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import {TranslateService} from '@ngx-translate/core';
import *  as $ from 'jquery';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { zonasUTC } from 'app/main/pagina/zonasUtc';

///IDIOMAS
//import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
//import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { lang_shedule } from 'app/idiomas/i18n/shedule35/shedule35.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
const moment = require('moment');
const momentTz = require('moment-timezone');
import {FormControl} from '@angular/forms';
@Component({
  selector: 'formadialog35',
  templateUrl: './formadialog35.component.html',
  styleUrls: ['./formadialog35.component.scss'],

})
export class Formadialog35Component{
  @ViewChild('inputFecha', { read: MatInput }) input: MatInput;
  idiomaActual:string;
  fechas: any[] = [
    {icono: 'send', tipo: "lanzamiento", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
    {icono: 'filter_1', tipo: "aviso1", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
    {icono: 'filter_2', tipo: "aviso2", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
    {icono: 'power_settings_new', tipo: "cierre", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
  ];
  columnas: string[] = ['tipoFecha', 'fechaElegida', 'acciones'];
  origen: number;

  fechaLanza: any;

  filtroCalendario: any;
  filtroCalendarioDefault:any

  filtroHoraHoy: any;



  filtroAviso1 = (d: Date | null): boolean => {
    var moment = require('moment');
    const diaInicial = moment();
    // const diaFinal = moment(this.fechaLanza).add(21,'days');
    const diaFinal = moment(this.fechaLanza);
    const diaActual = moment(d || new Date());
    return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
  };

  filtroAviso2 = (d: Date | null): boolean => {
    var moment = require('moment');
    const diaInicial = moment(this.fechas[1].fecha);
    // const diaFinal = moment(this.fechaLanza).add(21,'days');
    const diaFinal = moment(this.fechaLanza);
    const diaActual = moment(d || new Date());
    return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
  };

  filtroCierre = (d: Date | null): boolean => {
    let moment = require('moment');
    // let diaInicial = moment(this.fechas[1].fecha);
    let diaInicial: any;
    if(this.fechas[2].fecha != ""){
      diaInicial = moment(this.fechas[2].fecha);
    }
    else{
      if(this.fechas[1].fecha != ""){
        diaInicial = moment(this.fechas[1].fecha);
      }
      else{
        diaInicial = moment(this.fechas[0].fecha);
      }
    }
    const diaActual = moment(d || new Date());
    return diaActual.isAfter(diaInicial)
  };

  fechaAnterior = "";

  //zonas horarias
  zonasUTC = zonasUTC;
  indiceZona: number;
  horaInstituto: any;
  horaInstitutoTag: any;
  esHoy: boolean;
  horaMinima: string;
  diferenciaUtc: number;
  offsetPipe: string;
  startDate = new Date(2021,11, 11);

  constructor(
    public dialogRef: MatDialogRef<Formadialog35Component>,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      lang_shedule.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.idiomaActual = this.translateSrv.currentLang;
      this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });

    }
    ngOnInit(){
      this.rangoLanza();
    }
    onNoClick(): void {
	    this.dialogRef.close('close');
    }

    calculoOffsetPipe(){
      this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
      console.log("diferenciaUtc:",this.diferenciaUtc);
      let horas = this.diferenciaUtc / 60;
      if(horas < 0){
        horas = horas * -1;
        if(horas < 10){
          this.offsetPipe = "-0" + horas + "00";
        }
        else{
          this.offsetPipe = "-" + horas + "00";
        }
      }
      else{
        if(horas < 10){
          this.offsetPipe = "+0" + horas + "00";
        }
        else{
          this.offsetPipe = "+" + horas + "00";
        }
      }
      console.log("offsetPipe:",this.offsetPipe);
    }

    calculoHoraMinima(){
      let horaMinima = this.horaInstituto.clone().add(4,'hours').format('YYYY-MM-DD');
      let horaActual = moment().format('YYYY-MM-DD');
      // console.log("horaMinima:",horaMinima," horaActual:",horaActual);
      let esHoy = moment(horaActual).isSame(horaMinima);
      this.esHoy = esHoy;
      // console.log("es aun hoy?:",esHoy);
    }


    alineaFechaUTC(fecha:string){
      let fechaElegidaAjustada = momentTz.tz(fecha,this.zonasUTC[this.indiceZona].zona).utc(true);
      return fechaElegidaAjustada.format();
    }

    resetFecha() {
      this.input.value = '';
    }



    setFiltroHoraHoy(hoy:boolean,diaSiguiente?:boolean){
      if(hoy){
        console.log("aplicado filtro de hora para hoy");
        // let horaActualMasCuatro = moment().add(4,'hours');
        let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
        if(horaActualMasCuatro.hours() > 12){
          this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
        }
        else{
          this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
        }
      }
      else{
        if(diaSiguiente){
          console.log("aplicado filtro de hora del dia siguiente a hoy");
          if(this.esHoy){
            this.filtroHoraHoy = "00:00 am";
          }
          else{
            let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
            if(horaActualMasCuatro.hours() > 12){
              this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
            }
            else{
              this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
            }
          }
        }
        else{
          console.log("aplicado filtro de hora para otro dia");
          this.filtroHoraHoy = "00:00 am";
        }
      }

      console.log("filtroHoraHoy:",this.filtroHoraHoy);
    }





    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 2000,
      });
    }

    horaAbierta(event){
      console.log("horaAbierta:",event);
    }

    salirSinHora(event){
      console.log("salirSinHora:",event);
      if(this.fechas[this.origen].hora == ""){
        this.fechas[this.origen].fecha = this.fechaAnterior;
      }
    }

    filtroLanzamiento = (d: Date | null): boolean => {
      /*let horaMinima = this.horaInstituto.clone().add(4,'hours').format('YYYY-MM-DD');
      let horaActual = moment().format('YYYY-MM-DD');
      // console.log("horaMinima:",horaMinima," horaActual:",horaActual);
      let esHoy = moment(horaActual).isSame(horaMinima);
      this.esHoy = esHoy;*/


      let fechaMinima: any;
      if(this.esHoy){
        fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') >= moment().format('MM/DD/YYYY')
      }
      else{
        fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
      }
      return fechaMinima;
    };
    rangoLanza(){
      this.filtroCalendario = this.filtroLanzamiento;
      this.filtroCalendarioDefault = new FormControl(new Date());
      let horaActualMasCuatro = this.filtroCalendarioDefault.clone().add(4,'hours');
      this.filtroCalendarioDefault=horaActualMasCuatro;
      console.log(this.filtroCalendarioDefault);
    }
    rangoAviso1(){
      this.filtroCalendario = this.filtroAviso1;
      this.filtroCalendarioDefault = new FormControl(new Date());
      console.log(this.filtroCalendarioDefault);
    }
    rangoAviso2(){
      this.filtroCalendario = this.filtroAviso2;
      this.filtroCalendarioDefault = new FormControl(new Date());
      console.log(this.filtroCalendarioDefault);
    }

    rangoCierre(){
      this.filtroCalendario = this.filtroCierre;
      this.filtroCalendarioDefault = new FormControl(new Date(this.fechas[3].fecha));
      console.log(this.filtroCalendarioDefault);



    }

    salir() {
      let status = true;
      let BreakException = {};
      try {
          this.fechas.forEach( (fecha,i) => {
            if(i != 1 && i != 2){
              if(!fecha.elegida){
                status = false;
                throw BreakException;
              }
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.dialogRef.close({
        status,
        fechaLanzamiento: this.fechaLanza,
        fechaCierre: this.fechas[3].fecha
      });
    }

}
